/* gy-birthday-preview.js — SKU #8 "The Family Birthday Wall" · live PDP preview
 * ONE file serves BOTH concepts. Branch is chosen by data-concept on the host.
 *
 * HOST (printed by the gy_preview custom-liquid block):
 *   <div id="gy-bw"
 *        data-concept="B"        B = Calendar Ledger · D = Four Seasons
 *        data-bg-b="<cdn url of gy-birthday-nen-b.jpg>"
 *        data-bg-d="<cdn url of gy-birthday-nen-d.jpg>"></div>
 *
 * RULES BAKED IN (source: giao-B-va-D/SKU8-B-LAYOUT.json · SKU8-D-LAYOUT.json ·
 * DOC-VONG-3.txt v3 2026-08-15 · compositor/text_engine.py):
 *  - The background is the REAL print background image, background-size:100% 100%.
 *    Nothing about the design is re-drawn in CSS. No bg url => polite message, no fake art.
 *  - Only the text layers are drawn, from the % boxes in the LAYOUT files.
 *  - px_preview = px_in * (frame width / 4800).
 *  - Widths are MEASURED with canvas 2D measureText at 100px then divided by 100
 *    (= unit()). Never counted in characters. Ceilings differ per concept.
 *  - Font readiness is proven with the _fingerprint.json probe widths, NOT with
 *    document.fonts.check() / getComputedStyle() — both of those report green
 *    while the browser is still painting the fallback serif.
 */
(function () {
  'use strict';

  var W = 4800, H = 6000;                 // print canvas, px
  var FLOOR_NAME = 71.43;                 // 12 pt @ 11x14
  var FLOOR_DATE = 47.62;                 // 8 pt  @ 11x14

  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
                'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  var MONTH_NAME = ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'];

  var F_SERIF  = 'Cormorant Garamond';
  var F_SANS   = 'Jost';
  var F_SCRIPT = 'Pinyon Script';

  var GF_URL = 'https://fonts.googleapis.com/css2?family=Pinyon+Script' +
               '&family=Cormorant+Garamond:wght@400;500;600' +
               '&family=Jost:wght@300;400;500&display=swap';

  /* ------------------------------------------------------------------ specs */
  /* B — Calendar Ledger. 3 cols x 4 rows, name LEFT + date RIGHT on one line,
     small-caps. Boxes derived from SKU8-B-LAYOUT.json ("thang" array). */
  var SPEC_B = {
    id: 'B',
    maxPerMonth: 7,
    maxTotal: 30,
    nameUnitMax: 11.5167,      // tran_cung.ten_unit_toi_da
    nameCharsSafe: 19,         // fallback when fonts cannot be measured
    title1: { y: 6.8, sizeMax: 312, floor: 156, unitMax: 26.9231 },
    title2: { sizeMax: 516, floor: 180, unitMax: 23.3333 },
    name: { ls: 0.02, sc: true, boxW: 822.62, align: 'left' },
    date: { ls: 0.02, boxW: 423.78, align: 'right' },
    availH: 679.44,
    sizeMax: 186,
    kd: 0.45 * 1.06,           // 0.477
    color: { t1: '#806A79', t2: '#3E3A33', name: '#3E3A33', date: '#6E6A61' },
    months: (function () {
      var a = [];
      for (var i = 0; i < 12; i++) {
        var c = i % 3, r = Math.floor(i / 3);
        a.push({
          id: MONTHS[i],
          xName: 7.85 + c * 29.1667,
          xDateL: 24.988 + c * 29.1667,
          xDateR: 33.8167 + c * 29.1667,
          y: 27.271 + r * 16.875
        });
      }
      return a;
    })()
  };

  /* D — Four Seasons. 4 season blocks, name + date STACKED and centred in the
     column, name wrapped by WORD. Boxes from SKU8-D-LAYOUT.json ("thang"). */
  var SPEC_D = {
    id: 'D',
    maxPerMonth: 4,
    maxTotal: 24,
    wordUnitMax: 8.3199,       // tran_cung.tu_unit_toi_da — per WORD, not per name
    wordCharsSafe: 11,
    title1: { y: 6.2, sizeMax: 312, floor: 156, unitMax: 26.9231 },
    title2: { sizeMax: 492, floor: 180, unitMax: 23.3333 },
    name: { ls: 0.005, sc: false, boxW: 603.33, align: 'center' },
    date: { ls: 0.03, boxW: 603.33, align: 'center' },
    fitW: 594.28,              // max width of ONE name line
    bandH: 957.48,             // height of the name stack inside a season block
    sizeMax: 156,
    kd: 0.45,
    color: { t1: '#806A79', t2: '#3E3A33', name: '#3E3A33', date: '#6E6A61' },
    months: (function () {
      var xs = [7.107, 21.3903, 35.6737, 51.757, 66.0403, 80.3237];
      var order = ['MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG',
                   'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB'];
      var a = [];
      for (var i = 0; i < 12; i++) {
        a.push({ id: order[i], xName: xs[i % 6], y: i < 6 ? 41.4 : 78.342 });
      }
      return a;
    })()
  };

  /* ------------------------------------------------- canvas 2D measuring rig */
  var mctx = (function () {
    var c = document.createElement('canvas');
    c.width = 8; c.height = 8;
    return c.getContext('2d');
  })();
  var HAS_LS = ('letterSpacing' in mctx);

  function rawWidth(text, family, weight, sizePx, lsEm, sc) {
    mctx.font = weight + ' ' + sizePx + 'px "' + family + '"';
    mctx.fontKerning = 'auto';
    try { mctx.fontVariantCaps = sc ? 'small-caps' : 'normal'; } catch (e) {}
    var lsPx = (lsEm || 0) * sizePx;
    if (HAS_LS) {
      mctx.letterSpacing = lsPx + 'px';
      return mctx.measureText(text).width;
    }
    /* No native letterSpacing (old Safari): add it the way Chromium does —
       after EVERY character including the last one. */
    return mctx.measureText(text).width + lsPx * text.length;
  }

  var uCache = {};
  /* unit(): width measured at 100px, divided by 100. Width is linear in size,
     so unit works for every size. This is exactly what the compositor uses. */
  function unit(text, family, weight, lsEm, sc) {
    var k = family + '|' + weight + '|' + (lsEm || 0) + '|' + (sc ? 1 : 0) + '|' + text;
    if (uCache[k] === undefined) uCache[k] = rawWidth(text, family, weight, 100, lsEm, sc) / 100;
    return uCache[k];
  }

  /* Font readiness: the probe strings + expected widths from
     khop-pixel/_fingerprint.json. If the fallback serif is still painting,
     these numbers are wildly off, which is the only honest signal we have. */
  var PROBE = 'HAMBURGEFONTSIV hamburgefontsiv 0123456789 &.';
  var FINGERPRINT = [
    [F_SERIF, 600, 2222.000],
    [F_SERIF, 400, 2200.800],
    [F_SANS, 300, 2300.800],
    [F_SCRIPT, 400, 2290.576]
  ];
  function fontsProven(tol) {
    tol = tol || 8;                       // px at 100px = 0.35% of the probe
    for (var i = 0; i < FINGERPRINT.length; i++) {
      var f = FINGERPRINT[i];
      var got = rawWidth(PROBE, f[0], f[1], 100, 0, false);
      if (Math.abs(got - f[2]) > tol) return false;
    }
    return true;
  }

  /* ------------------------------------------------------------ text helpers */
  function tachTu(name) {
    /* '&' rides along with the word AFTER it: "Sarah & Tom" -> ["Sarah","& Tom"] */
    var t = name.split(/\s+/).filter(Boolean), out = [], i = 0;
    while (i < t.length) {
      if (t[i] === '&' && i + 1 < t.length) { out.push(t[i] + ' ' + t[i + 1]); i += 2; }
      else { out.push(t[i]); i += 1; }
    }
    return out.length ? out : [name];
  }

  function ngatDong(name, size, spec) {
    /* greedy word wrap, same rule as compositor_D.ngat_dong */
    var lines = [], cur = '', w = tachTu(name);
    for (var i = 0; i < w.length; i++) {
      var thu = cur ? cur + ' ' + w[i] : w[i];
      if (cur && unit(thu, F_SERIF, 600, spec.name.ls, spec.name.sc) * size > spec.fitW) {
        lines.push(cur); cur = w[i];
      } else cur = thu;
    }
    if (cur) lines.push(cur);
    return lines;
  }

  var MON3 = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
              'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  /* Turn whatever the customer typed into the printed M.D.YYYY. Returns null
     when we genuinely cannot read it — that is a blocking error, because the
     compositor only ever prints M.D.YYYY. */
  function normDate(s) {
    var t = String(s).trim().replace(/,/g, ' ').replace(/\s+/g, ' ');
    if (!t) return null;
    var m, mo, d, y;
    m = t.match(/^(\d{1,2})\s*[.\/-]\s*(\d{1,2})\s*[.\/-]\s*(\d{4})$/);
    if (m) { mo = +m[1]; d = +m[2]; y = +m[3]; }
    if (!m) {
      m = t.match(/^([A-Za-z]{3,9})\.?\s+(\d{1,2})(?:st|nd|rd|th)?\s+(\d{4})$/);
      if (m) { mo = MON3.indexOf(m[1].slice(0, 3).toLowerCase()) + 1; d = +m[2]; y = +m[3]; }
    }
    if (!m) {
      m = t.match(/^(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]{3,9})\.?\s+(\d{4})$/);
      if (m) { mo = MON3.indexOf(m[2].slice(0, 3).toLowerCase()) + 1; d = +m[1]; y = +m[3]; }
    }
    if (!m || !mo || mo < 1 || mo > 12 || !d || d < 1 || d > 31 || y < 1800 || y > 2200) return null;
    return mo + '.' + d + '.' + y;
  }

  /* --------------------------------------------------------------- one size */
  function coChuB(data, spec) {
    var maxCount = 0, uMax = 1e-9, mid, i;
    for (mid in data) {
      if (!data[mid].length) continue;
      if (data[mid].length > maxCount) maxCount = data[mid].length;
      for (i = 0; i < data[mid].length; i++) {
        var u = unit(data[mid][i].name, F_SERIF, 600, spec.name.ls, spec.name.sc);
        if (u > uMax) uMax = u;
      }
    }
    var capPerMonth = (spec.availH / Math.max(1, maxCount)) / 1.34;
    var capWidth = spec.name.boxW / uMax;
    var sizeTen = Math.min(spec.sizeMax, capPerMonth, capWidth);
    var sizeNgay = Math.min(sizeTen * 0.80, spec.date.boxW / (10 * spec.kd));
    return { ten: sizeTen, ngay: sizeNgay, maxCount: maxCount, uMax: uMax,
             ok: sizeTen >= FLOOR_NAME && sizeNgay >= FLOOR_DATE };
  }

  function coChuD(data, spec) {
    var uMax = 1e-9, mid, i, j;
    for (mid in data) {
      for (i = 0; i < data[mid].length; i++) {
        var w = tachTu(data[mid][i].name);
        for (j = 0; j < w.length; j++) {
          var u = unit(w[j], F_SERIF, 600, spec.name.ls, spec.name.sc);
          if (u > uMax) uMax = u;
        }
      }
    }
    var sizeTen = Math.min(spec.sizeMax, spec.fitW / uMax);
    var sizeNgay;
    for (var loop = 0; loop < 6; loop++) {
      sizeNgay = Math.min(sizeTen * 0.72, spec.date.boxW / (10 * spec.kd));
      var cao = 0;
      for (mid in data) {
        var h = 0;
        for (i = 0; i < data[mid].length; i++) {
          h += ngatDong(data[mid][i].name, sizeTen, spec).length * 1.06 * sizeTen
             + 0.12 * sizeTen + 1.2 * sizeNgay + 66;
        }
        if (h > cao) cao = h;
      }
      if (cao <= spec.bandH) break;
      sizeTen *= spec.bandH / cao * 0.995;
    }
    sizeNgay = Math.min(sizeTen * 0.72, spec.date.boxW / (10 * spec.kd));
    return { ten: sizeTen, ngay: sizeNgay, uMax: uMax,
             ok: sizeTen >= FLOOR_NAME && sizeNgay >= FLOOR_DATE };
  }

  /* -------------------------------------------------------------- the layers */
  function plan(order, spec, proven) {
    var out = [], boxW = 0.875 * W, boxX = (W - boxW) / 2;

    var t1 = order.title1 || 'Our Family';
    var s1 = Math.min(spec.title1.sizeMax, boxW / unit(t1, F_SCRIPT, 400, 0, false));
    var y1 = spec.title1.y / 100 * H;
    out.push({ text: t1, fam: F_SCRIPT, w: 400, size: s1, ls: 0, sc: false,
               col: spec.color.t1, align: 'center', ax: W / 2, y: y1 });

    var t2 = (order.title2 || 'BIRTHDAYS').toUpperCase();
    var s2 = Math.min(spec.title2.sizeMax, boxW / unit(t2, F_SERIF, 600, 0.085, false));
    var y2 = y1 + s1 * 1.02;
    out.push({ text: t2, fam: F_SERIF, w: 600, size: s2, ls: 0.085, sc: false,
               col: spec.color.t2, align: 'center', ax: W / 2, y: y2 });

    var size = spec.id === 'B' ? coChuB(order.months, spec) : coChuD(order.months, spec);
    var i, k, m, e;

    for (i = 0; i < spec.months.length; i++) {
      m = spec.months[i];
      var list = order.months[m.id] || [];
      if (!list.length) continue;                 // empty month: draw NOTHING

      if (spec.id === 'B') {
        var lineH = size.ten * 1.34;
        var top = m.y / 100 * H;
        var first = top + Math.max(0, (spec.availH - lineH * list.length) / 2);
        for (k = 0; k < list.length; k++) {
          e = list[k];
          var y = first + k * lineH;
          out.push({ text: e.name, fam: F_SERIF, w: 600, size: size.ten,
                     ls: spec.name.ls, sc: true, col: spec.color.name,
                     align: 'left', ax: m.xName / 100 * W, y: y });
          out.push({ text: e.date, fam: F_SANS, w: 300, size: size.ngay,
                     ls: spec.date.ls, sc: false, col: spec.color.date,
                     align: 'right', ax: m.xDateR / 100 * W,
                     y: y + (size.ten - size.ngay) * 0.72 });
        }
      } else {
        var yy = m.y / 100 * H;
        var cx = (m.xName / 100 * W) + spec.name.boxW / 2;
        for (k = 0; k < list.length; k++) {
          e = list[k];
          var lines = ngatDong(e.name, size.ten, spec);
          for (var L = 0; L < lines.length; L++) {
            out.push({ text: lines[L], fam: F_SERIF, w: 600, size: size.ten,
                       ls: spec.name.ls, sc: false, col: spec.color.name,
                       align: 'center', ax: cx, y: yy });
            yy += 1.06 * size.ten;
          }
          out.push({ text: e.date, fam: F_SANS, w: 300, size: size.ngay,
                     ls: spec.date.ls, sc: false, col: spec.color.date,
                     align: 'center', ax: cx, y: yy + 0.12 * size.ten });
          yy += 0.12 * size.ten + 1.2 * size.ngay + 66;
        }
      }
    }
    return { layers: out, size: size, s1: s1, s2: s2, proven: proven };
  }

  /* ------------------------------------------------------------- the ceiling */
  function check(order, spec, proven) {
    var errs = [];       // { key: <property key or null>, msg: '...' }
    var total = 0, mid, i, j;

    for (i = 0; i < 12; i++) {
      mid = MONTHS[i];
      var list = order.months[mid] || [];
      total += list.length;
      if (list.length > spec.maxPerMonth) {
        errs.push({ key: MONTH_NAME[i],
          msg: MONTH_NAME[i] + ' has ' + list.length + ' names. This print holds ' +
               spec.maxPerMonth + ' in a month. Please take ' +
               (list.length - spec.maxPerMonth) + ' out.' });
      }
      for (j = 0; j < list.length; j++) {
        var e = list[j];
        if (e.dateRaw && !e.date) {
          errs.push({ key: MONTH_NAME[i],
            msg: 'We cannot read the date "' + e.dateRaw + '". Please write it like 3.4.2011.' });
        }
        if (spec.id === 'B') {
          var tooWide = proven
            ? unit(e.name, F_SERIF, 600, spec.name.ls, spec.name.sc) > spec.nameUnitMax
            : e.name.length > spec.nameCharsSafe;
          if (tooWide) {
            errs.push({ key: MONTH_NAME[i],
              msg: '"' + e.name + '" is too wide for this print. Please shorten it - a first name, or a first name and one initial, always fits.' });
          }
        } else {
          var words = tachTu(e.name);
          for (var q = 0; q < words.length; q++) {
            var bad = proven
              ? unit(words[q], F_SERIF, 600, spec.name.ls, spec.name.sc) > spec.wordUnitMax
              : words[q].length > spec.wordCharsSafe;
            if (bad) {
              errs.push({ key: MONTH_NAME[i],
                msg: '"' + words[q].replace(/^&\s*/, '') + '" is too wide for this print. Please use a shorter name - about ' + spec.wordCharsSafe + ' letters fits.' });
              break;
            }
          }
        }
      }
    }

    if (total > spec.maxTotal) {
      errs.push({ key: null,
        msg: 'You have ' + total + ' names. This print holds ' + spec.maxTotal +
             '. Please take ' + (total - spec.maxTotal) + ' out.' });
    }

    if (order.title1 && unit(order.title1, F_SCRIPT, 400, 0, false) > spec.title1.unitMax) {
      errs.push({ key: 'Title line 1',
        msg: 'This line is too long to print. Please make it shorter.' });
    }
    var t2 = (order.title2 || '').toUpperCase();
    if (t2 && unit(t2, F_SERIF, 600, 0.085, false) > spec.title2.unitMax) {
      errs.push({ key: 'Title line 2',
        msg: 'This line is too long to print. Please make it shorter.' });
    }

    /* Belt and braces: if the one-size-for-the-whole-print maths lands under the
       12 pt / 8 pt floor, the compositor raises BelowFloor and the paid order
       jams. Catch it here instead. */
    if (total) {
      var sz = spec.id === 'B' ? coChuB(order.months, spec) : coChuD(order.months, spec);
      if (!sz.ok && !errs.length) {
        errs.push({ key: null,
          msg: 'This is a little more than the print can hold. Please shorten the longest name, or take one name out.' });
      }
    }
    return errs;
  }

  /* ------------------------------------------------------------------- style */
  function injectOnce(id, make) {
    if (document.getElementById(id)) return;
    var n = make(); n.id = id;
    (document.head || document.documentElement).appendChild(n);
  }

  function boot() {
    injectOnce('gy-bw-gf', function () {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = GF_URL; l.crossOrigin = 'anonymous';
      return l;
    });
    injectOnce('gy-bw-css', function () {
      var s = document.createElement('style');
      s.textContent = [
        '#gy-bw{margin:16px 0}',
        '#gy-bw .gybw-frame{position:relative;width:100%;padding-top:125%;',
        '  background-repeat:no-repeat;background-position:center;background-size:100% 100%;',
        '  background-color:#FBF7EC;border-radius:3px;overflow:hidden;',
        '  box-shadow:0 1px 10px rgba(0,0,0,.14)}',
        '#gy-bw .gybw-ink{position:absolute;inset:0}',
        '#gy-bw .gybw-t{position:absolute;white-space:pre;margin:0;padding:0;',
        '  text-indent:0;text-transform:none!important;font-style:normal!important;',
        '  font-feature-settings:normal;-webkit-font-smoothing:antialiased}',
        /* The trap: theme CSS reaches child nodes and swallows the family.
           Name the family on the element AND on every descendant. */
        '#gy-bw .gybw-serif,#gy-bw .gybw-serif *{font-family:"Cormorant Garamond",Garamond,serif!important;font-weight:600!important}',
        '#gy-bw .gybw-script,#gy-bw .gybw-script *{font-family:"Pinyon Script",cursive!important;font-weight:400!important}',
        '#gy-bw .gybw-sans,#gy-bw .gybw-sans *{font-family:"Jost",system-ui,sans-serif!important;font-weight:300!important}',
        '#gy-bw .gybw-sc,#gy-bw .gybw-sc *{font-variant-caps:small-caps!important;-webkit-font-variant-caps:small-caps!important}',
        '#gy-bw .gybw-note{margin:10px 0 0;font-size:15px;line-height:1.45;color:#3E3A33}',
        '#gy-bw .gybw-sub{margin:2px 0 0;font-size:13px;line-height:1.45;color:#6E6A61}',
        '#gy-bw .gybw-hold{display:flex;align-items:center;justify-content:center;',
        '  text-align:center;padding:34px 22px;border:1px solid #E3DCCB;border-radius:3px;',
        '  background:#FBF7EC;color:#6E6A61;font-size:15px;line-height:1.5}',
        '#gy-bw-warn{display:none;margin:12px 0;padding:12px 14px;border-radius:8px;',
        '  background:#FDECEA;color:#8A1C14;font-size:16px;line-height:1.5}',
        '#gy-bw-warn.on{display:block}',
        '.gybw-err{margin:6px 0 0;padding:8px 10px;border-radius:6px;background:#FDECEA;',
        '  color:#8A1C14;font-size:15px;line-height:1.45}',
        'textarea.custom-property__input{min-height:4.2em!important;overflow-y:hidden;transition:height .12s ease}',
        'product-custom-property-component .__character-count{background:#fff;padding:0 3px;border-radius:3px}'
      ].join('');
      return s;
    });
  }

  /* -------------------------------------------------------------- form input */
  function fields() {
    var l = document.querySelectorAll(
      'product-custom-property-component .custom-property__input, ' +
      'product-custom-property-component textarea, ' +
      'product-custom-property-component input[type=text]');
    if (l.length) return l;
    return document.querySelectorAll('[name^="properties["]');
  }

  function keyOf(el) {
    var n = el.getAttribute('name') || '';
    var m = n.match(/properties\[(.+?)\]/);
    if (m) return m[1].trim();
    var host = el.closest ? el.closest('product-custom-property-component') : null;
    if (host) {
      var lab = host.querySelector('label, legend, .custom-property__heading');
      if (lab) return (lab.textContent || '').split('\n')[0].trim();
      return (host.textContent || '').split('\n')[0].trim();
    }
    return '';
  }

  function readOrder() {
    var order = { title1: '', title2: '', months: {}, any: false }, i;
    for (i = 0; i < 12; i++) order.months[MONTHS[i]] = [];

    var list = fields();
    for (i = 0; i < list.length; i++) {
      var el = list[i], key = keyOf(el), val = (el.value || '').trim();
      if (!key) continue;
      var kl = key.toLowerCase();
      if (kl.indexOf('title') === 0) {
        if (/2/.test(key)) order.title2 = val; else order.title1 = val;
        if (val) order.any = true;
        continue;
      }
      var mi = -1;
      for (var j = 0; j < 12; j++) {
        if (kl.slice(0, 3) === MON3[j]) { mi = j; break; }
      }
      if (mi < 0) continue;
      var rows = val.split('\n');
      for (var r = 0; r < rows.length; r++) {
        var line = rows[r].trim();
        if (!line) continue;
        order.any = true;
        var sep = line.match(/^([\s\S]*?)\s+[-–—]\s+([\s\S]*)$/);
        var nm = sep ? sep[1].trim() : line;
        var dt = sep ? sep[2].trim() : '';
        order.months[MONTHS[mi]].push({ name: nm, dateRaw: dt, date: dt ? normDate(dt) : '' });
      }
    }
    return order;
  }

  var SAMPLE = {
    title1: 'Our Family', title2: 'BIRTHDAYS',
    months: {
      JAN: [{ name: 'Ruth', date: '1.9.1948' }],
      FEB: [],
      MAR: [{ name: 'Emma', date: '3.4.2011' }, { name: 'Noah', date: '3.22.2016' }],
      APR: [],
      MAY: [{ name: 'Margaret', date: '5.18.1952' }],
      JUN: [{ name: 'Sarah & Tom', date: '6.18.1971' }],
      JUL: [{ name: 'James', date: '7.2.1980' }],
      AUG: [{ name: 'Ava', date: '8.9.2014' }],
      SEP: [],
      OCT: [{ name: 'Ruth Ann', date: '10.28.1958' }],
      NOV: [],
      DEC: [{ name: 'Grace', date: '12.25.1999' }, { name: 'Henry', date: '12.3.1946' }]
    }
  };
  function sampleOrder() {
    var o = { title1: SAMPLE.title1, title2: SAMPLE.title2, months: {} };
    for (var i = 0; i < 12; i++) {
      o.months[MONTHS[i]] = (SAMPLE.months[MONTHS[i]] || []).map(function (e) {
        return { name: e.name, dateRaw: e.date, date: e.date };
      });
    }
    return o;
  }

  /* ------------------------------------------------------------ add to cart */
  var BUY_SEL = 'button[name="add"],.add-to-cart-button,add-to-cart-component button,' +
                '.product-form__submit,[data-testid="add-to-cart"]';
  function setBuy(disabled) {
    var b = document.querySelectorAll(BUY_SEL);
    for (var i = 0; i < b.length; i++) {
      if (disabled) {
        b[i].setAttribute('disabled', 'disabled');
        b[i].setAttribute('aria-disabled', 'true');
        b[i].style.opacity = '.5';
        b[i].style.cursor = 'not-allowed';
      } else if (b[i].getAttribute('aria-disabled') === 'true') {
        b[i].removeAttribute('disabled');
        b[i].removeAttribute('aria-disabled');
        b[i].style.opacity = '';
        b[i].style.cursor = '';
      }
    }
  }

  function clearInline() {
    var e = document.querySelectorAll('.gybw-err');
    for (var i = 0; i < e.length; i++) e[i].parentNode.removeChild(e[i]);
  }
  function showInline(key, msg) {
    var list = fields();
    for (var i = 0; i < list.length; i++) {
      if (keyOf(list[i]) !== key) continue;
      var host = list[i].closest ? (list[i].closest('product-custom-property-component') || list[i]) : list[i];
      var d = document.createElement('div');
      d.className = 'gybw-err';
      d.textContent = msg;
      host.parentNode.insertBefore(d, host.nextSibling);
      return true;
    }
    return false;
  }

  /* ------------------------------------------------------------------ render */
  var host, spec, ink, frame, warn, subEl, raf = 0;

  function variantLabel() {
    var picked = document.querySelectorAll(
      'variant-picker input:checked, variant-picker select, .product-form__input input:checked');
    var parts = [];
    for (var i = 0; i < picked.length; i++) {
      var v = picked[i].value || '';
      if (v && parts.indexOf(v) < 0) parts.push(v);
    }
    var s = parts.join(' / ') || host.getAttribute('data-variant') || '';
    return s.replace(/(\d)\s*[xX]\s*(\d)/g, '$1 × $2');   /* U+00D7, never the letter x */
  }

  function render() {
    if (!host) return;
    var proven = fontsProven();
    var order = readOrder();
    var isSample = !order.any;
    var draw = isSample ? sampleOrder() : order;

    /* --- ceiling: always runs, even when the background is missing --- */
    var errs = isSample ? [] : check(order, spec, proven);
    clearInline();
    var seen = {}, summary = [];
    for (var i = 0; i < errs.length; i++) {
      var e = errs[i];
      if (seen[e.msg]) continue;
      seen[e.msg] = 1;
      summary.push(e.msg);
      if (e.key) showInline(e.key, e.msg);
    }
    if (summary.length) {
      warn.className = 'on';
      warn.innerHTML = '<strong>Please fix this before you order:</strong>';
      var ul = document.createElement('ul');
      ul.style.cssText = 'margin:6px 0 0;padding-left:20px';
      for (i = 0; i < Math.min(summary.length, 5); i++) {
        var li = document.createElement('li');
        li.textContent = summary[i];
        ul.appendChild(li);
      }
      warn.appendChild(ul);
      setBuy(true);
    } else {
      warn.className = '';
      warn.textContent = '';
      setBuy(false);
    }

    /* --- picture --- */
    if (!frame) return;
    var k = frame.clientWidth / W;
    if (!k) return;

    ink.textContent = '';
    ink.style.opacity = isSample ? '.82' : '1';

    var p;
    try { p = plan(draw, spec, proven); }
    catch (err) { return; }

    for (i = 0; i < p.layers.length; i++) {
      var L = p.layers[i];
      if (!L.text) continue;
      var s = L.size * k;
      if (s < 1) continue;
      var el = document.createElement('div');
      el.className = 'gybw-t ' + (L.fam === F_SERIF ? 'gybw-serif'
                    : L.fam === F_SANS ? 'gybw-sans' : 'gybw-script')
                    + (L.sc ? ' gybw-sc' : '');
      el.textContent = L.text;
      /* Width is linear in size, so unit() * s is the same number the
         compositor uses to place the layer. */
      var w = unit(L.text, L.fam, L.w, L.ls, L.sc) * s;
      var left = L.align === 'left' ? L.ax * k
               : L.align === 'right' ? L.ax * k - w
               : L.ax * k - w / 2;
      el.style.cssText =
        'left:' + left.toFixed(2) + 'px;top:' + (L.y * k).toFixed(2) + 'px;' +
        'font-size:' + s.toFixed(3) + 'px;line-height:' + s.toFixed(3) + 'px;' +
        'letter-spacing:' + (L.ls * s).toFixed(3) + 'px;color:' + L.col + ';';
      ink.appendChild(el);
    }

    if (subEl) {
      var v = variantLabel();
      subEl.textContent = v ? 'Shown at ' + v + (isSample ? ' · example names until you type your own' : '')
                            : (isSample ? 'Example names until you type your own' : '');
    }
  }

  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(render);
  }

  /* -------------------------------------------------------------------- init */
  function init() {
    host = document.getElementById('gy-bw');
    if (!host) return;
    boot();

    spec = (host.getAttribute('data-concept') || 'B').toUpperCase() === 'D' ? SPEC_D : SPEC_B;

    var bg = (host.getAttribute(spec.id === 'D' ? 'data-bg-d' : 'data-bg-b') || '').trim();

    host.textContent = '';
    if (bg) {
      frame = document.createElement('div');
      frame.className = 'gybw-frame';
      frame.style.backgroundImage = 'url("' + bg.replace(/"/g, '%22') + '")';
      ink = document.createElement('div');
      ink.className = 'gybw-ink';
      frame.appendChild(ink);
      host.appendChild(frame);
    } else {
      var hold = document.createElement('div');
      hold.className = 'gybw-hold';
      hold.textContent = 'The picture of this print is on its way. Your names and dates are still checked as you type, and they print exactly as you write them.';
      host.appendChild(hold);
      frame = null; ink = null;
    }

    var note = document.createElement('p');
    note.className = 'gybw-note';
    note.textContent = 'This is your actual design. Please check every spelling before you order.';
    host.appendChild(note);

    subEl = document.createElement('p');
    subEl.className = 'gybw-sub';
    host.appendChild(subEl);

    warn = document.getElementById('gy-bw-warn');
    if (!warn) {
      warn = document.createElement('div');
      warn.id = 'gy-bw-warn';
      host.appendChild(warn);
    }

    /* textarea auto-grow + redraw on every keystroke */
    function wire() {
      var list = fields();
      if (!list.length) return setTimeout(wire, 400);
      var min = parseFloat(getComputedStyle(list[0]).minHeight) || 70;
      for (var i = 0; i < list.length; i++) {
        (function (t) {
          if (t.__gybw) return;
          t.__gybw = 1;
          function grow() {
            if (t.tagName !== 'TEXTAREA') return;
            t.style.height = 'auto';
            t.style.height = Math.max(t.scrollHeight, min) + 'px';
          }
          t.addEventListener('input', function () { grow(); schedule(); });
          t.addEventListener('change', schedule);
          grow();
        })(list[i]);
      }
      schedule();
    }
    wire();

    var form = host.closest ? host.closest('form') : null;
    if (form) form.addEventListener('change', schedule);
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('variant-picker')) schedule();
    }, true);
    ['variant:update', 'variantChange', 'variant:change', 'product:variant-change']
      .forEach(function (n) { document.addEventListener(n, schedule); });

    var rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { uCache = {}; render(); }, 140);
    });

    /* Fonts: never trust document.fonts.check() or getComputedStyle() — both
       go green while the fallback serif is still on screen. Redraw on a few
       clocks instead and re-measure each time. */
    if (document.fonts) {
      try {
        Promise.all([
          document.fonts.load('600 100px "Cormorant Garamond"'),
          document.fonts.load('400 100px "Cormorant Garamond"'),
          document.fonts.load('300 100px "Jost"'),
          document.fonts.load('400 100px "Pinyon Script"')
        ]).then(function () { uCache = {}; render(); });
      } catch (e) {}
      if (document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(function () { uCache = {}; render(); });
      }
    }
    setTimeout(function () { uCache = {}; render(); }, 900);
    setTimeout(function () { uCache = {}; render(); }, 2200);

    render();
  }

  /* Test hook. Harmless in the browser; lets the node harness drive the REAL
     ceiling functions instead of a copy of them. */
  var API = { unit: unit, check: check, coChuB: coChuB, coChuD: coChuD,
              tachTu: tachTu, ngatDong: ngatDong, normDate: normDate,
              fontsProven: fontsProven, SPEC_B: SPEC_B, SPEC_D: SPEC_D };
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  else if (typeof window !== 'undefined') window.GYBW = API;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
